import { render, staticRenderFns } from "./GiveAway.vue?vue&type=template&id=19d0f5d2&"
import script from "./GiveAway.vue?vue&type=script&lang=js&"
export * from "./GiveAway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports